import { alpha, Box, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import DatePicker from 'views/common/components/UI/DatePicker';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .TBWPrice': {
    fontSize: theme.typography.pxToRem(24),
    fontWeight: 500,
  },
  '& .TBWPackageSelector, .TBWDatePickerTextField': {
    '&:hover': {
      backgroundColor: theme.palette.divider[5],
    },
    '& .MuiInputBase-root': {
      cursor: 'pointer',
    },
    '& .MuiInputBase-input': {
      padding: theme.spacing(2, 3, 1.75, 0.5),
      cursor: 'pointer',
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'unset',
      borderWidth: 1,
    },
  },
  '& .TBWTimeText': {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 500,
    lineHeight: '150%',
  },
  '& .TBWSlotsWrapper': {
    display: 'flex',
    gap: theme.spacing(1.25),
    justifyContent: 'space-between',
  },
  '& .TBWTimeSlot': {
    padding: theme.spacing(1.25, 1.5),
    flex: 1,
    border: '1px solid',
    borderColor: alpha(theme.palette.common.white, 0.5),
    borderRadius: 4,
    '&.TBWActive': {
      borderColor: theme.palette.primary.main,
    },
  },
  '& .TBWError': {
    backgroundColor: theme.palette.error.background,
    fontWeight: 700,
    marginTop: theme.spacing(2),
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
    '& .MuiAlert-icon': {
      padding: 0,
      marginRight: theme.spacing(1),
    },
    '& .MuiAlert-message': {
      padding: 0,
    },
  },
  '& .TBWErrorIcon': {
    color: theme.palette.error.light,
    fontSize: theme.spacing(2.5),
  },
  '& .TBWOccurrenceBadge': {
    color: theme.palette.error.light,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: '100%',
    fontWeight: 500,
  },
  '& .TBWSoldOutBadge': {
    verticalAlign: 'text-top',
    marginLeft: theme.spacing(0.8),
  },
}));

export const StyledMenuPaper = styled(Paper)(({ theme }) => ({
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#888',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#555',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: '#888 transparent',
  '& .TBWPackageItem': {
    justifyContent: 'center',
    border: '1px solid',
    borderColor: 'transparent',
    '&:hover': {
      border: '1px solid',
      borderColor: alpha(theme.palette.common.white, 0.8),
      borderRadius: 4,
    },
  },
}));

export const StyledDatePicker = styled(DatePicker)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  borderRadius: 8,
  border: '1px solid',
  width: theme.typography.pxToRem(330),
  borderColor: theme.palette.divider[7],
  boxShadow: '0px 0px 50px 0px rgba(255, 255, 255, 0.25);',
  backdropFilter: 'blur(8px)',
  '& .MuiButtonBase-root, .MuiDayCalendar-weekDayLabel': {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 400,
    lineHeight: '140%',
  },
  '& .MuiPickersArrowSwitcher-button .MuiSvgIcon-root': {
    width: theme.typography.pxToRem(24),
    height: theme.typography.pxToRem(24),
  },
}));
export default StyledBox;
